export const useDetermineValueToShow = () => {
  const MINIMUM_VALUE = 2;

  const determineInterval = (sellingRate) => {
    const { last_two_days, last_day, last_hour } = sellingRate;

    if (last_hour > MINIMUM_VALUE) return "Hour";
    if (last_day > MINIMUM_VALUE) return "Day";
    if (last_two_days > MINIMUM_VALUE) return "Two Days";
    return null;
  };

  const determineNumberSold = (sellingRate) => {
    const { last_two_days, last_day, last_hour } = sellingRate;

    if (last_hour > MINIMUM_VALUE) return last_hour;
    if (last_day > MINIMUM_VALUE) return last_day;
    if (last_two_days > MINIMUM_VALUE) return last_two_days;
    return null;
  };

  return {
    determineInterval,
    determineNumberSold
  };
};
